import React from "react";
import { ProductMediaTabs } from "components/ProductConfigurator/components/Media/ProductMediaTabs";
import { TechnicalInputs } from "components/ProductConfigurator/components/Results/components/SingleSelectionTab/components/TechnicalInputs";
import { AcousticResults } from "components/ProductConfigurator/components/Results/components/SingleSelectionTab/components/AcousticResults";
import { TechnicalResults } from "components/ProductConfigurator/components/Results/components/SingleSelectionTab/components/TechnicalResults";

export const ModalTechnicalProperties = () => {
  return (
    <>
      <TechnicalInputs />
      <AcousticResults />
      <TechnicalResults />
      <div className="d-flex justify-content-center mx-3 border rounded">
        <ProductMediaTabs />
      </div>
    </>
  );
};
